import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Media } from "reactstrap";
import OpenFileLink from "../Components/OpenFileLink";
import { joinCss } from "../helpers/utils";

import appClasses from "../App.module.scss";
import classes from "./TableRow.module.scss";

import editionImage from "../images/editionSmall.png";
import fixImage from "../images/fixSmall.png";

class tableRow extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(event, data) {
    this.props.history.push("/AllSpecifications/" + data.id, data);
  }
  render() {
    let rowClasses = joinCss(
      classes.tableLine,
      "mb-2",
      appClasses["vertical-center-parent"]
    );
    return (
      <Row
        key={this.props.data.docIdentity}
        className={
          this.props.tableSettings.rowIsLink
            ? joinCss(rowClasses, classes.tableLineLink)
            : rowClasses
        }
        onClick={
          this.props.tableSettings.rowIsLink
            ? e => this.handleClick(e, this.props.data)
            : ""
        }
      >
        {this.props.tableSettings.columns.map((column, index) => {
          let imageObj = null;
          if (column.image) {
            let image;
            let alt;
            if (column.image === "edition") {
              image = editionImage;
              alt = "מהדורה";
            } else {
              image = fixImage;
              alt = "תיקון";
            }
            imageObj = <Media object className="ml-1" src={image} alt={alt} />;
          }
          let baseClassForCol = joinCss(
            classes.dataRowCol,
            appClasses["vertical-40-center-child"]
          );
          let classForCol =
            index === 0
              ? joinCss(classes.boldFont, baseClassForCol)
              : baseClassForCol;
          const TagName = column.component;
          const fileLink = column.component ? (
            <TagName data={this.props.data} />
          ) : (
            <OpenFileLink
              localClass={joinCss(classes.pdfName)}
              contant={this.props.data.pdfName}
              numOfLines="1"
              id={this.props.data.id}
              textLocalClass={classes.pdfTextClass}
            />
          );
          const contant =
            column.type === "fileLink" ? (
              <Col
                className={classForCol}
                key={
                  this.props.data.docIdentity + this.props.data[column.property]
                }
                sm={column.size}
              >
                {fileLink}
              </Col>
            ) : (
              <Col
                className={classForCol}
                key={
                  this.props.data.docIdentity + this.props.data[column.property]
                }
                sm={column.size}
              >
                {imageObj}
                {this.props.data[column.property]}
              </Col>
            );
          return contant;
        })}
      </Row>
    );
  }
}

export default withRouter(tableRow);
